// import React, { useState, useRef, useEffect } from "react";
// import {
//   useReactTable,
//   getCoreRowModel,
//   getPaginationRowModel,
//   getSortedRowModel,
//   getFilteredRowModel,
//   flexRender,
// } from "@tanstack/react-table";
// import { useReactToPrint } from "react-to-print";
// import * as XLSX from "xlsx";
// import { FaFileExcel, FaPrint, FaSearch } from "react-icons/fa";
// import { GrFormNext } from "react-icons/gr";
// import { GrFormPrevious } from "react-icons/gr";
// // ─── Design tokens ────────────────────────────────────────────────────────────
// const T = {
//   brown: "#5c3d11",
//   brownDark: "#3e2005",
//   orange: "#e07b2a",
//   bgHead: "#f0f4f8",    // clean cool-grey thead
//   borderHead: "#dde4ec",
//   borderCell: "#eef2f7",
//   textHead: "#3a5a7a",    // slate blue-grey header labels
//   textCell: "#1a1a1a",
//   rowHover: "#fdf6ee",
//   footerBg: "#faf3eb",    // dark brown — matches header
//   footerText: "#201403",    // warm gold text on brown
//   font: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
// };

// function InjectStyles() {
//   useEffect(() => {
//     const id = "crt-styles-v4";
//     if (!document.getElementById(id)) {
//       const el = document.createElement("style");
//       el.id = id; el.textContent = CSS;
//       document.head.appendChild(el);
//     }
//   }, []);
//   return null;
// }

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// function isNumericValue(val) {
//   if (val === null || val === undefined || val === "") return false;
//   return !isNaN(Number(val)) && String(val).trim() !== "";
// }
// function isNumericColumn(data, accessorKey) {
//   if (!accessorKey) return false;
//   const s = data.filter(r => r[accessorKey] != null).slice(0, 3);
//   return s.length > 0 && s.every(r => isNumericValue(r[accessorKey]));
// }


// // ─── Component ────────────────────────────────────────────────────────────────
// export default function CommonReactTable({
//   columns, data, headerName,
//   showPagination = true,
//   showFooter = "false",
//   align = "right",
//   decimal,
//   showPrint = true,
//   showExcel = true,
//   excelFileName,

// }) {
//   const [globalFilter, setGlobalFilter] = useState("");
//   const [hoveredRow, setHoveredRow] = useState(null);
//   const [pagination, setPagination] = useState({
//     pageIndex: 0,
//     pageSize: showPagination ? 10 : (data?.length || 0),
//   });


//   useEffect(() => {
//     if (!showPagination) {
//       setPagination((prev) => ({
//         ...prev,
//         pageSize: data?.length || 0,
//       }));
//     }
//   }, [data, showPagination]);

//   const table = useReactTable({
//     data, columns,
//     state: { globalFilter, pagination },
//     onPaginationChange: setPagination,
//     onGlobalFilterChange: setGlobalFilter,
//     getCoreRowModel: getCoreRowModel(),
//     getPaginationRowModel: getPaginationRowModel(),
//     getSortedRowModel: getSortedRowModel(),
//     getFilteredRowModel: getFilteredRowModel(),
//   });

//   const rows = table.getRowModel().rows;
//   const { pageIndex, pageSize } = pagination;

//   const tableRef = useRef();

//   const handlePrint = useReactToPrint({
//     contentRef: tableRef,
//     documentTitle: excelFileName || "Report",
//   });

//   const handleExcelExport = () => {
//     const headerGroups = table.getHeaderGroups();
//     const leafCols = table.getVisibleLeafColumns();
//     const dataRows = table.getRowModel().rows;
//     const maxDepth = headerGroups.length;
//     const colCount = leafCols.length;

//     const occupied = Array.from({ length: maxDepth }, () => new Array(colCount).fill(false));
//     const headerMatrix = Array.from({ length: maxDepth }, () => new Array(colCount).fill(""));
//     const merges = [];

//     headerGroups.forEach((group, rowIdx) => {
//       let colCursor = 0;

//       group.headers.forEach((header) => {
//         while (colCursor < colCount && occupied[rowIdx][colCursor]) colCursor++;

//         const colSpan = header.colSpan || 1;
//         const isLeaf = !header.subHeaders || header.subHeaders.length === 0;
//         const rowSpan = header.isPlaceholder ? 1 : (isLeaf ? maxDepth - rowIdx : 1);

//         const label = header.isPlaceholder
//           ? ""
//           : typeof header.column.columnDef.header === "string"
//             ? header.column.columnDef.header
//             : header.column.id;

//         if (!header.isPlaceholder) {
//           headerMatrix[rowIdx][colCursor] = label;
//         }

//         for (let r = rowIdx; r < rowIdx + rowSpan; r++) {
//           for (let c = colCursor; c < colCursor + colSpan; c++) {
//             if (r !== rowIdx || c !== colCursor) occupied[r][c] = true;
//           }
//         }

//         if (colSpan > 1 || rowSpan > 1) {
//           merges.push({
//             s: { r: rowIdx, c: colCursor },
//             e: { r: rowIdx + rowSpan - 1, c: colCursor + colSpan - 1 },
//           });
//         }

//         colCursor += colSpan;
//       });
//     });

//     const bodyRows = dataRows.map((row, i) =>
//       leafCols.map((col) => {
//         if (col.id === "slNo") return i + 1;

//         const def = col.columnDef;
//         const hasAccessor = def.accessorKey || def.accessorFn;

//         if (hasAccessor) {
//           const raw = row.getValue(col.id);
//           if (raw === null || raw === undefined || raw === "") return "";
//           const asNum = Number(raw);
//           return isNaN(asNum) ? raw : asNum;
//         }

//         if (typeof def.cell === "function") {
//           try {
//             const result = def.cell({ row, getValue: () => undefined });
//             if (result === null || result === undefined) return "";
//             if (typeof result === "number" || typeof result === "string") return result;
//             const children = result?.props?.children;
//             if (typeof children === "string" || typeof children === "number") return children;
//             return "";
//           } catch {
//             return "";
//           }
//         }

//         return "";
//       })
//     );

//     const footerRow = leafCols.map((col) => {
//       const def = col.columnDef;
//       if (!def.Footer) return "";
//       if (def.Footer === "Total") return "Total";

//       if (typeof def.Footer === "function") {
//         try {
//           const result = def.Footer({ table });
//           if (result === null || result === undefined) return "";
//           if (typeof result === "number" || typeof result === "string") return result;
//           if (result?.props?.children !== undefined) return result.props.children;
//           return "";
//         } catch {
//           return "";
//         }
//       }

//       if (def.Footer === true) {
//         return rowsCount(def);
//       }

//       return "";
//     });

//     const hasFooter = footerRow.some((v) => v !== "");

//     const aoa = [
//       [headerName],
//       ...headerMatrix,
//       ...bodyRows,
//       ...(hasFooter ? [footerRow] : []),
//     ];

//     const ws = XLSX.utils.aoa_to_sheet(aoa);
//     ws["!merges"] = [
//       {
//         s: { r: 0, c: 0 },
//         e: { r: 0, c: colCount - 1 },
//       },
//       ...merges,
//     ];
//     const headingCell = XLSX.utils.encode_cell({ r: 0, c: 0 });

//     if (ws[headingCell]) {
//       ws[headingCell].s = {
//         alignment: {
//           horizontal: "center",
//           vertical: "center",
//         },
//         font: {
//           bold: true,
//           sz: 16,
//         },
//       };
//     }

//     const colWidths = Array(colCount).fill(10);
//     aoa.forEach((row) => {
//       row.forEach((cell, c) => {
//         const len = String(cell ?? "").length;
//         if (len > colWidths[c]) colWidths[c] = len;
//       });
//     });
//     ws["!cols"] = colWidths.map((w) => ({ wch: Math.min(w + 2, 40) }));

//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Report");
//     XLSX.writeFile(wb, `${excelFileName || "export"}.xlsx`);
//   };


//   function rowsCount(col) {
//     let sum = 0;
//     const rdata = data;
//     if (col?.FooterParamAction) {
//       const p = col.Footerparams?.split("-");
//       const p1 = rdata?.reduce((s, r) => s + (Number(r[p[0]]) || 0), 0);
//       const p2 = rdata?.reduce((s, r) => s + (Number(r[p[1]]) || 0), 0);
//       const p3 = rdata?.reduce((s, r) => s + (Number(r[p[2]]) || 0), 0);
//       if (col.FooterParamAction === "-") sum = p1 - p2 - p3;
//       else if (col.FooterParamAction === "/") sum = parseFloat(((p1 / p2) * 100).toFixed(1));
//       else sum = p1 + p2;
//     } else {
//       sum = rdata?.reduce((s, r) => s + (Number(r[col.accessorKey]) || 0), 0);
//     }
//     return !isNaN(sum) ? (decimal === "two" ? sum.toFixed(2) : sum) : "";
//   }

//   const totalRows = table.getFilteredRowModel().rows.length;
//   const allHeaders = table.getHeaderGroups();

//   function getLeafColumns(cols) {
//     let leaf = [];
//     cols.forEach(col => {
//       if (col.columns) {
//         leaf = leaf.concat(getLeafColumns(col.columns));
//       } else {
//         leaf.push(col);
//       }
//     });
//     return leaf;
//   }

//   const leafColumns = getLeafColumns(columns);

//   const numericColIds = new Set(
//     leafColumns
//       .filter(col => col.accessorKey && isNumericColumn(data, col.accessorKey))
//       .map(col => col.accessorKey)
//   );

//   const formatValue = (val) => {
//     if (val === null || val === undefined || val === "") {
//       return "-";
//     }
//     return val;
//   };

//   useEffect(() => {
//     const style = document.createElement("style");
//     style.innerHTML = `
//     @media print {
//       body * { visibility: hidden !important; }
//       .print-area, .print-area * { visibility: visible !important; }
//       .print-area { position: absolute !important; top: 0; left: 0; width: 100%; }
//       .table-responsive { overflow: visible !important; max-height: none !important; }
//       table { width: 100% !important; border-collapse: collapse !important; }
//       th { background: #3e2005 !important; color: white !important; }
//       tr, td { page-break-inside: avoid; }
//       thead { display: table-header-group; }
//       tfoot { display: table-row-group; }
//       .no-print { display: none !important; }
//     }
//   `;
//     document.head.appendChild(style);
//     return () => document.head.removeChild(style);
//   }, []);

//   return (
//     <>
//       <InjectStyles />
//       <div>
//         <div className="crt-card">

//           <div
//             className="crt-toolbar"
//             style={{
//               display: "flex",
//               justifyContent: "flex-end",
//               alignItems: "center",
//               width: "100%",
//             }}
//           >
//             <div
//               className="crt-toolbar-right mb-2"
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "8px",
//               }}
//             >
//               <div className="search-container">
//                 <FaSearch className="crt-search-icon" style={{ marginRight: "6px" }} />
//                 <input
//                   value={globalFilter ?? ""}
//                   onChange={(e) => setGlobalFilter(e.target.value)}
//                   placeholder="Search..."
//                   className="crt-search"
//                   style={{
//                     border: "none",
//                     outline: "none",
//                   }}
//                 />
//               </div>

//               {showExcel && (
//                 <button
//                   type="button"
//                   className="print-tablebtn btn-success btn btn-sm"
//                   onClick={handleExcelExport}
//                 >
//                   <FaFileExcel size={14} />
//                 </button>
//               )}

//               {showPrint && (
//                 <button
//                   type="button"
//                   className="print-tablebtn btn-primary btn btn-sm"
//                   onClick={handlePrint}
//                 >
//                   <FaPrint size={14} />
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Table */}
//           <div ref={tableRef} className="print-area">

//             {/* ── Only change: added maxHeight + overflowY so sticky works ── */}
//             <div
//               className="table-responsive"
//               style={{ maxHeight: "65vh", overflowY: "auto", position: "relative" }}
//             >
//               <table className="newreporttable table table-bordered table-hover" style={{ marginBottom: 0 }}>

//                 {/* ── Only change: added position sticky to thead ── */}
//                 <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
//                   {headerName && (
//                     <tr>
//                       <th
//                         colSpan={table.getVisibleLeafColumns().length}
//                         style={{
//                           textAlign: "center",
//                           fontWeight: "bold",
//                           fontSize: "18px",
//                           padding: "10px",
//                           backgroundColor: "#477053",
//                         }}
//                       >
//                         {headerName}
//                       </th>
//                     </tr>
//                   )}

//                   {table.getHeaderGroups().map((headerGroup) => (
//                     <tr key={headerGroup.id}>
//                       {headerGroup.headers.map((header) => (
//                         <th
//                           key={header.id}
//                           colSpan={header.colSpan}
//                           style={{
//                             textAlign: "center",
//                             verticalAlign: "middle",
//                             // ← no color changes, exactly as original
//                           }}
//                         >
//                           {header.isPlaceholder
//                             ? null
//                             : flexRender(
//                               header.column.columnDef.header,
//                               header.getContext()
//                             )}
//                         </th>
//                       ))}
//                     </tr>
//                   ))}
//                 </thead>

//                 <tbody>
//                   {rows.length === 0 ? (
//                     <tr><td colSpan={columns.length}>No Records Found</td></tr>
//                   ) : (
//                     rows.map((row, rowIdx) => (
//                       <tr
//                         key={row.id}
//                         onMouseEnter={() => setHoveredRow(rowIdx)}
//                         onMouseLeave={() => setHoveredRow(null)}
//                       >
//                         {row.getVisibleCells().map((cell, ci) => {
//                           const isLast = ci === row.getVisibleCells().length - 1;
//                           const colId = cell.column.columnDef.accessorKey;
//                           const isNum = numericColIds.has(colId);
//                           const isSlNo = cell.column.id === "slNo";
//                           const metaAlign = cell.column.columnDef.meta?.style?.textAlign;
//                           const resolvedAlign = metaAlign ? metaAlign : isNum ? "right" : "left";

//                           const bgStyle = cell.column.columnDef.color
//                             ? { backgroundColor: cell.column.columnDef.color, textAlign: resolvedAlign }
//                             : { textAlign: resolvedAlign };

//                           return (
//                             <td key={cell.id} style={{ ...bgStyle, width: cell.column.getSize() }}>
//                               {cell.column.columnDef.cell
//                                 ? formatValue(cell.column.columnDef.cell(cell.getContext()))
//                                 : formatValue(cell.getValue())}
//                             </td>
//                           );
//                         })}
//                       </tr>
//                     ))
//                   )}
//                 </tbody>

//                 {/* ── Only change: added position sticky to tfoot ── */}
//                 {showFooter && rows?.length !== 0 && (
//                   <tfoot
//                     className="newreporttable-foot"
//                     style={{ position: "sticky", bottom: 0, zIndex: 2 }}
//                   >
//                     <tr>
//                       {table.getAllLeafColumns().map(col => {
//                         const def = col.columnDef;

//                         const style = {
//                           ...(def.color ? { backgroundColor: def.color } : {}),
//                           ...(def.textColor ? { color: def.textColor } : {}),
//                           textAlign: "center",
//                           fontWeight: "bold"
//                         };

//                         let content = "";
//                         if (typeof def.Footer === "function") {
//                           content = flexRender(def.Footer, { table });
//                         } else if (def.Footer === "Total") {
//                           content = "Total";
//                         } else if (def.Footer === true) {
//                           content = rowsCount(def);
//                         }

//                         return (
//                           <td key={col.id} style={style}>
//                             {content}
//                           </td>
//                         );
//                       })}
//                     </tr>
//                   </tfoot>
//                 )}

//               </table>
//             </div>
//           </div>

//           {/* Pagination */}
//           {showPagination && (
//             <div className="crt-pagination">
//               <button
//                 onClick={() => table.previousPage()}
//                 disabled={!table.getCanPreviousPage()}
//               ><GrFormPrevious /></button>
//               <span>
//                 Page <strong>{pageIndex + 1}</strong> of{" "}
//                 <strong>{table.getPageCount()}</strong>
//               </span>
//               <button
//                 onClick={() => table.nextPage()}
//                 disabled={!table.getCanNextPage()}
//               ><GrFormNext /></button>
//             </div>
//           )}

//         </div>
//       </div>
//     </>
//   );
// }


import React, { useState, useRef, useEffect } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  flexRender,
} from "@tanstack/react-table";
import { useReactToPrint } from "react-to-print";
import * as XLSX from "xlsx";
import { FaFileExcel, FaPrint, FaSearch } from "react-icons/fa";
import { GrFormNext } from "react-icons/gr";
import { GrFormPrevious } from "react-icons/gr";
// ─── Design tokens ────────────────────────────────────────────────────────────
const T = {
  brown: "#5c3d11",
  brownDark: "#3e2005",
  orange: "#e07b2a",
  bgHead: "#f0f4f8",    // clean cool-grey thead
  borderHead: "#dde4ec",
  borderCell: "#eef2f7",
  textHead: "#3a5a7a",    // slate blue-grey header labels
  textCell: "#1a1a1a",
  rowHover: "#fdf6ee",
  footerBg: "#faf3eb",    // dark brown — matches header
  footerText: "#201403",    // warm gold text on brown
  font: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
};

function InjectStyles() {
  useEffect(() => {
    const id = "crt-styles-v4";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id; el.textContent = CSS;
      document.head.appendChild(el);
    }
  }, []);
  return null;
}

// ─── Helpers ──────────────────────────────────────────────────────────────────
function isNumericValue(val) {
  if (val === null || val === undefined || val === "") return false;
  return !isNaN(Number(val)) && String(val).trim() !== "";
}
function isNumericColumn(data, accessorKey) {
  if (!accessorKey) return false;
  const s = data.filter(r => r[accessorKey] != null).slice(0, 3);
  return s.length > 0 && s.every(r => isNumericValue(r[accessorKey]));
}


// ─── Component ────────────────────────────────────────────────────────────────
export default function CommonReactTable({
  columns, data, headerName,
  showPagination = true,
  showFooter = "false",
  align = "right",
  decimal,
  showPrint = true,
  showExcel = true,
  excelFileName,

}) {
  const [globalFilter, setGlobalFilter] = useState("");
  const [hoveredRow, setHoveredRow] = useState(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: showPagination ? 10 : (data?.length || 0),
  });


  useEffect(() => {
    if (!showPagination) {
      setPagination((prev) => ({
        ...prev,
        pageSize: data?.length || 0,
      }));
    }
  }, [data, showPagination]);

  const table = useReactTable({
    data, columns,
    state: { globalFilter, pagination },
    onPaginationChange: setPagination,
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });

  const rows = table.getRowModel().rows;
  const { pageIndex, pageSize } = pagination;

  const tableRef = useRef();

  const handlePrint = useReactToPrint({
    contentRef: tableRef,
    documentTitle: excelFileName || "Report",
  });

  const handleExcelExport = () => {
    const headerGroups = table.getHeaderGroups();
    const leafCols = table.getVisibleLeafColumns();
    const dataRows = table.getRowModel().rows;
    const maxDepth = headerGroups.length;
    const colCount = leafCols.length;

    const occupied = Array.from({ length: maxDepth }, () => new Array(colCount).fill(false));
    const headerMatrix = Array.from({ length: maxDepth }, () => new Array(colCount).fill(""));
    const merges = [];

    headerGroups.forEach((group, rowIdx) => {
      let colCursor = 0;

      group.headers.forEach((header) => {
        while (colCursor < colCount && occupied[rowIdx][colCursor]) colCursor++;

        const colSpan = header.colSpan || 1;
        const isLeaf = !header.subHeaders || header.subHeaders.length === 0;
        const rowSpan = header.isPlaceholder ? 1 : (isLeaf ? maxDepth - rowIdx : 1);

        const label = header.isPlaceholder
          ? ""
          : typeof header.column.columnDef.header === "string"
            ? header.column.columnDef.header
            : header.column.id;

        if (!header.isPlaceholder) {
          headerMatrix[rowIdx][colCursor] = label;
        }

        for (let r = rowIdx; r < rowIdx + rowSpan; r++) {
          for (let c = colCursor; c < colCursor + colSpan; c++) {
            if (r !== rowIdx || c !== colCursor) occupied[r][c] = true;
          }
        }

        if (colSpan > 1 || rowSpan > 1) {
          merges.push({
            s: { r: rowIdx, c: colCursor },
            e: { r: rowIdx + rowSpan - 1, c: colCursor + colSpan - 1 },
          });
        }

        colCursor += colSpan;
      });
    });

    const bodyRows = dataRows.map((row, i) =>
      leafCols.map((col) => {
        if (col.id === "slNo") return i + 1;

        const def = col.columnDef;
        const hasAccessor = def.accessorKey || def.accessorFn;

        if (hasAccessor) {
          const raw = row.getValue(col.id);
          if (raw === null || raw === undefined || raw === "") return "";
          const asNum = Number(raw);
          return isNaN(asNum) ? raw : asNum;
        }

        if (typeof def.cell === "function") {
          try {
            const result = def.cell({ row, getValue: () => undefined });
            if (result === null || result === undefined) return "";
            if (typeof result === "number" || typeof result === "string") return result;
            const children = result?.props?.children;
            if (typeof children === "string" || typeof children === "number") return children;
            return "";
          } catch {
            return "";
          }
        }

        return "";
      })
    );

    const footerRow = leafCols.map((col) => {
      const def = col.columnDef;
      if (!def.Footer) return "";
      if (def.Footer === "Total") return "Total";

      if (typeof def.Footer === "function") {
        try {
          const result = def.Footer({ table });
          if (result === null || result === undefined) return "";
          if (typeof result === "number" || typeof result === "string") return result;
          if (result?.props?.children !== undefined) return result.props.children;
          return "";
        } catch {
          return "";
        }
      }

      if (def.Footer === true) {
        return rowsCount(def);
      }

      return "";
    });

    const hasFooter = footerRow.some((v) => v !== "");

    const aoa = [
      [headerName],
      ...headerMatrix,
      ...bodyRows,
      ...(hasFooter ? [footerRow] : []),
    ];

    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws["!merges"] = [
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: colCount - 1 },
      },
      ...merges,
    ];
    const headingCell = XLSX.utils.encode_cell({ r: 0, c: 0 });

    if (ws[headingCell]) {
      ws[headingCell].s = {
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
        font: {
          bold: true,
          sz: 16,
        },
      };
    }

    const colWidths = Array(colCount).fill(10);
    aoa.forEach((row) => {
      row.forEach((cell, c) => {
        const len = String(cell ?? "").length;
        if (len > colWidths[c]) colWidths[c] = len;
      });
    });
    ws["!cols"] = colWidths.map((w) => ({ wch: Math.min(w + 2, 40) }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${excelFileName || "export"}.xlsx`);
  };


  function rowsCount(col) {
    let sum = 0;
    const rdata = data;
    if (col?.FooterParamAction) {
      const p = col.Footerparams?.split("-");
      const p1 = rdata?.reduce((s, r) => s + (Number(r[p[0]]) || 0), 0);
      const p2 = rdata?.reduce((s, r) => s + (Number(r[p[1]]) || 0), 0);
      const p3 = rdata?.reduce((s, r) => s + (Number(r[p[2]]) || 0), 0);
      if (col.FooterParamAction === "-") sum = p1 - p2 - p3;
      else if (col.FooterParamAction === "/") sum = parseFloat(((p1 / p2) * 100).toFixed(1));
      else sum = p1 + p2;
    } else {
      sum = rdata?.reduce((s, r) => s + (Number(r[col.accessorKey]) || 0), 0);
    }
    return !isNaN(sum) ? (decimal === "two" ? sum.toFixed(2) : sum) : "";
  }

  const totalRows = table.getFilteredRowModel().rows.length;
  const allHeaders = table.getHeaderGroups();

  function getLeafColumns(cols) {
    let leaf = [];
    cols.forEach(col => {
      if (col.columns) {
        leaf = leaf.concat(getLeafColumns(col.columns));
      } else {
        leaf.push(col);
      }
    });
    return leaf;
  }

  const leafColumns = getLeafColumns(columns);

  const numericColIds = new Set(
    leafColumns
      .filter(col => col.accessorKey && isNumericColumn(data, col.accessorKey))
      .map(col => col.accessorKey)
  );

  const formatValue = (val) => {
    if (val === null || val === undefined || val === "") {
      return "-";
    }
    return val;
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
    @media print {
      body * { visibility: hidden !important; }
      .print-area, .print-area * { visibility: visible !important; }
      .print-area { position: absolute !important; top: 0; left: 0; width: 100%; }
      .table-responsive { overflow: visible !important; max-height: none !important; }
      table { width: 100% !important; border-collapse: collapse !important; }
      th { background: #3e2005 !important; color: white !important; }
      tr, td { page-break-inside: avoid; }
      thead { display: table-header-group; }
      tfoot { display: table-row-group; }
      .no-print { display: none !important; }
    }
  `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  // ✅ slNo fixed style — applied to both <th> and <td>
  const slNoStyle = {
    width: "50px",
    minWidth: "50px",
    maxWidth: "50px",
    whiteSpace: "nowrap",
  };

  return (
    <>
      <InjectStyles />
      <div>
        <div className="crt-card">

          <div
            className="crt-toolbar"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div
              className="crt-toolbar-right mb-2"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <div className="search-container">
                <FaSearch className="crt-search-icon" style={{ marginRight: "6px" }} />
                <input
                  value={globalFilter ?? ""}
                  onChange={(e) => setGlobalFilter(e.target.value)}
                  placeholder="Search..."
                  className="crt-search"
                  style={{
                    border: "none",
                    outline: "none",
                  }}
                />
              </div>

              {showExcel && (
                <button
                  type="button"
                  className="print-tablebtn btn-success btn btn-sm"
                  onClick={handleExcelExport}
                >
                  <FaFileExcel size={14} />
                </button>
              )}

              {showPrint && (
                <button
                  type="button"
                  className="print-tablebtn btn-primary btn btn-sm"
                  onClick={handlePrint}
                >
                  <FaPrint size={14} />
                </button>
              )}
            </div>
          </div>

          {/* Table */}
          <div ref={tableRef} className="print-area">

            <div
              className="table-responsive"
              style={{ maxHeight: "65vh", overflowY: "auto", position: "relative" }}
            >
              <table className="newreporttable table table-bordered table-hover" style={{ marginBottom: 0 }}>

                <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                  {headerName && (
                    <tr>
                      <th
                        colSpan={table.getVisibleLeafColumns().length}
                        style={{
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "18px",
                          padding: "10px",
                          backgroundColor: "#477053",
                        }}
                      >
                        {headerName}
                      </th>
                    </tr>
                  )}

                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <th
                          key={header.id}
                          colSpan={header.colSpan}
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                            // ✅ slNo fix in <th>
                            ...(header.column.id === "slNo" && slNoStyle),
                          }}
                        >
                          {header.isPlaceholder
                            ? null
                            : flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody>
                  {rows.length === 0 ? (
                    <tr><td colSpan={columns.length}>No Records Found</td></tr>
                  ) : (
                    rows.map((row, rowIdx) => (
                      <tr
                        key={row.id}
                        onMouseEnter={() => setHoveredRow(rowIdx)}
                        onMouseLeave={() => setHoveredRow(null)}
                      >
                        {row.getVisibleCells().map((cell, ci) => {
                          const isLast = ci === row.getVisibleCells().length - 1;
                          const colId = cell.column.columnDef.accessorKey;
                          const isNum = numericColIds.has(colId);
                          const isSlNo = cell.column.id === "slNo";
                          const metaAlign = cell.column.columnDef.meta?.style?.textAlign;
                          const resolvedAlign = metaAlign ? metaAlign : isNum ? "right" : "left";

                          const bgStyle = cell.column.columnDef.color
                            ? { backgroundColor: cell.column.columnDef.color, textAlign: resolvedAlign }
                            : { textAlign: resolvedAlign };

                          return (
                            <td
                              key={cell.id}
                              style={{
                                ...bgStyle,
                                width: cell.column.getSize(),
                                // ✅ slNo fix in <td>
                                ...(isSlNo && slNoStyle),
                              }}
                            >
                              {cell.column.columnDef.cell
                                ? formatValue(cell.column.columnDef.cell(cell.getContext()))
                                : formatValue(cell.getValue())}
                            </td>
                          );
                        })}
                      </tr>
                    ))
                  )}
                </tbody>

                {showFooter && rows?.length !== 0 && (
                  <tfoot
                    className="newreporttable-foot"
                    style={{ position: "sticky", bottom: 0, zIndex: 2 }}
                  >
                    <tr>
                      {table.getAllLeafColumns().map(col => {
                        const def = col.columnDef;

                        const style = {
                          ...(def.color ? { backgroundColor: def.color } : {}),
                          ...(def.textColor ? { color: def.textColor } : {}),
                          textAlign: "center",
                          fontWeight: "bold",
                          // ✅ slNo fix in <tfoot>
                          ...(col.id === "slNo" && slNoStyle),
                        };

                        let content = "";
                        if (typeof def.Footer === "function") {
                          content = flexRender(def.Footer, { table });
                        } else if (def.Footer === "Total") {
                          content = "Total";
                        } else if (def.Footer === true) {
                          content = rowsCount(def);
                        }

                        return (
                          <td key={col.id} style={style}>
                            {content}
                          </td>
                        );
                      })}
                    </tr>
                  </tfoot>
                )}

              </table>
            </div>
          </div>

          {/* Pagination */}
          {showPagination && (
            <div className="crt-pagination">
              <button
                onClick={() => table.previousPage()}
                disabled={!table.getCanPreviousPage()}
              ><GrFormPrevious /></button>
              <span>
                Page <strong>{pageIndex + 1}</strong> of{" "}
                <strong>{table.getPageCount()}</strong>
              </span>
              <button
                onClick={() => table.nextPage()}
                disabled={!table.getCanNextPage()}
              ><GrFormNext /></button>
            </div>
          )}

        </div>
      </div>
    </>
  );
}